import React, { useContext, useEffect } from "react";
import { withRouter } from "./withRouter";
import { Outlet, Navigate } from "react-router-dom";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { theme } from "../theme";
import { GlobalContext } from "../context/Provider";
import { useNavigate, useLocation } from "react-router-dom";
import { logoutDoctor } from "../utils";
import { getDoctorState } from "../context/actions/auth/getDoctorState";
import { getDecryptedDataFromSessionStorage } from "../utils";
import { SECRET_KEY } from "../constants/encriptKey";

function UserAuthRoute({ allowedStates, redirectPath = "/" }) {
  const { userState, setUserState } = useContext(GlobalContext);
  const navigate = useNavigate();
  const location = useLocation();

  const rutasOmitidas = [
    "/backoffice",
    "/formulario-vista-previa/:appId",
    "/configuration/:appId",
    "/documentacion",
    "/clients/:clientId",
    "/clients/new",
    "/configuration",
    "/home",
    "/users/edit/:userId",
    "/users/new",
    "/users",
    "/medical-staff/profile/:uId",
    "/medical-staff",
  ];

  const data = getDecryptedDataFromSessionStorage(SECRET_KEY);
  const { token } = data || {};

  useEffect(() => {
    if (token && !rutasOmitidas.includes(location.pathname)) {
      getDoctorState({ token: token.toString() })
        .then((response) => {
          setUserState(response.result);
        })
        .catch((error) => {
          console.error("Error al obtener el estado del doctor:", error);
        });
    }
  }, [token, location.pathname, setUserState]);

  useEffect(() => {
    if (token) {
      const currentState = userState;
      if (!allowedStates.includes(currentState)) {
        if (currentState === "3" || currentState === "4") {
          logoutDoctor();
          navigate("/");
        } else {
          navigate("/dashboard");
        }
      }
    }
  }, [token]);

  if (!token) {
    return <Navigate to={redirectPath} />;
  }

  return (
    <div style={{ display: "flex", background: "white" }}>
      <MuiThemeProvider theme={theme}>
        <Outlet />
      </MuiThemeProvider>
    </div>
  );
}

export default withRouter(UserAuthRoute);
